import React, { Component } from 'react'
import bem from '../../../common/bem'

import './Page.scss'


export default class Page extends Component {

  constructor() {
    super()
  }
  render() {

    const { className, children } = this.props

    return (
      <section className={`${bem('page').element('container')} ${className}`}>
        { children }
      </section>
    )
  }
}

Page.defaultProps = {
  className: ''
}



// WEBPACK FOOTER //
// ./component/ui/Page/Page.js